import React from 'react';
import { Form } from 'antd';
import { SError, SSmsCodeWrapper } from './SmsCodeForm.styles';
import { SmsCodeInput } from './SmsCodeInput';
import { ISmsFormProps, ISmsFormValues } from './SmsCodeForm.types';

export const SmsCodeForm: React.FC<ISmsFormProps> = ({ handleCompletion, onCompletion, checkError, generateError, inputTheme = 'sms-code', size = 5, separatorsAfter = [], className }) => {
  const [form] = Form.useForm();
  const currentError = checkError || generateError;

  const handleFormChange = () => {
    const values = form.getFieldsValue();
    const smsCode = values.smsCode || '';
    const isCompleted = smsCode.length === size;
    
    if (isCompleted) {
      onCompletion?.(false);
      handleCompletion(smsCode);
    } else {
      onCompletion?.(true);
    }
  };

  const onFinish = (values: ISmsFormValues) => {
    handleCompletion(values.smsCode);
  };

  return (
    <Form autoComplete="off" form={form} requiredMark={false} onFieldsChange={handleFormChange} onFinish={onFinish}>
      <SSmsCodeWrapper className={className}>
        <SmsCodeInput name="smsCode" inputTheme={inputTheme} hasSubmitError={Boolean(currentError)} size={size} separatorsAfter={separatorsAfter} />
        {currentError && <SError>{currentError}</SError>}
      </SSmsCodeWrapper>
    </Form>
  );
}; 